import { useEffect, useState, useRef } from "react";
import classnames from "classnames";
import { MultiSelect } from "react-multi-select-component";

import FormField, { STYLE } from "components/FormField";
import ContentHeader from "../ContentHeader";
import UserInfo from "components/UserInfo";
import trucksService from "services/trucks.service";
import {formatPhoneNumber} from '../helpers'

import styles from "./GeneralInfo.module.scss";

const GeneralInfo = ({ fetchData, updateData, errors }) => {
  const [users, setUsers] = useState([]);
  const {associatedUserErr,unitError, dispatcherNameErr, dispatcherPhoneErr} = errors
  //data for req
  let [selected, setSelected] = useState([]);
  let [unit, setUnit] = useState(null)
  let [name, setName] = useState(null)
  let [phone, setPhone] = useState(null)
  // References to track previous states
  const prevSelectedRef = useRef(selected);
  const prevUnitRef = useRef(unit);
  const prevNameRef = useRef(name);
  const prevPhoneRef = useRef(phone);

  const usersOptions =
  users &&
  users?.map(({ photo_url, first_name, last_name, id }) => {
    return {
      label: <UserInfo src={photo_url} name={first_name + " " + last_name} />,
      value: `${first_name} ${last_name}`,
      id: id
    };
  });

  const teamRenderer = (selected) => {
    

    if (selected?.length > 1) {
      return (
        <>
          {`${selected.length} selected`}
        </>
      );
    } else if (selected?.length === 1) {
      const element = selected[0]?.label.props;
      return <UserInfo src={element.src} name={element.name} className="photo" />;
    }
  };

  const teamFilterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }
    return options.filter(({ label }) => {
      return label && label?.props?.name.toLowerCase().includes(filter);
    });
  };

  useEffect(() => {
    trucksService.getUsersList().then(
      ({ data }) => data?.length && setUsers(data),
      (error) => console.error(error),
    );
  }, []);

  useEffect(()=> {
    const prevSelected = prevSelectedRef.current;
    const prevUnit = prevUnitRef.current;
    const prevName = prevNameRef.current;
    const prevPhone = prevPhoneRef.current;

    if (prevSelected !== selected) {
      const preparedAsocciatedIds = selected.map((item) => item.id);
      updateData('associated_users_ids', null, [...preparedAsocciatedIds]);
    }
    if (prevUnit !== unit) {
      updateData('unit', null, unit);
    }
    if (prevName !== name) {
      updateData('dispatcher', null, { name });
    }
    if (prevPhone !== phone) {
      updateData('dispatcher', null, { phone_number: phone ? `+1${phone}` : null });
    }

    prevSelectedRef.current = selected;
    prevUnitRef.current = unit;
    prevNameRef.current = name;
    prevPhoneRef.current = phone;
  }, [ selected, unit, name, phone])

  const handleChange = (event) => {
    const { value } = event.target;
    const formattedValue = formatPhoneNumber(value)
    
    setPhone(formattedValue);
  };

  return (
    <>
      <div className={styles.wrapper}>
      <ContentHeader
        title="General Info"
        // handleClickBack={() => setCurrentScreen("")}
        className={styles.header}
      />
        <div className={styles.group}>
            <div className={styles.group_item}>
            <label className={styles.label}>
              Associated User <span className={styles.red}>*</span>
            </label>
            <MultiSelect
              className={classnames(styles.select, styles.withPhotos)}
              options={usersOptions}
              value={selected}
              onChange={setSelected}
              labelledBy={"Select"}
              valueRenderer={teamRenderer}
              filterOptions={teamFilterOptions}
              closeOnChangedValue={true}
              hasSelectAll={true}
              error={associatedUserErr}
              showArrow={true}
            />
            {associatedUserErr && <div className={styles.error}>{associatedUserErr}</div>}
            </div>
            <div className={styles.group_item}>
              <label className={styles.label}>
                Unit <span className={styles.red}>*</span>
              </label>
              <FormField
                value={unit}
                style={STYLE.FORM}
                onChange={(e) => setUnit(e.target.value)}
                error={unitError ? true : false}
                errorMessage={unitError}
                className={styles.errorMessage}
              />
            </div>
        </div>
        <div className={styles.group}>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Dispatcher's Name 
            </label>
            <FormField
              value={name}
              style={STYLE.FORM}
              onChange={(e) => setName(e.target.value)}
              error={dispatcherNameErr ? true : false}
              errorMessage={dispatcherNameErr}
              className={styles.errorMessage}
            />
          </div>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Dispatcher's Phone Number 
            </label>
            <FormField
              value={phone}
              style={STYLE.FORM_PHONE}
              onChange={handleChange}
              error={dispatcherPhoneErr ? true : false}
              errorMessage={dispatcherPhoneErr}
              className={styles.errorMessage}
            />
            <p className={styles.before}>+1</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralInfo;

